export const TrustStrip = () => {
  return (
    <div
      className="bg-[#F7F6F2] py-8 border-t border-[#E1DFD7]"
      data-testid="trust-strip"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-sm text-[#4C5A70] font-medium mb-1">
            Kohari Gonzalez Oneyear & Brown — CPAs & Advisors
          </p>
          <p className="text-xs text-[#9CA3AF]">
            Based in North Carolina • Serving Clients Across the U.S. • Let's Talk Growth<sup>®</sup>
          </p>
        </div>
      </div>
    </div>
  );
};
